var path = '/templates/projects.dashboard/conversion_price_chart.html';
var html = "<div class=widget-header><h5>{{ 'projectsDashboard.conversionPriceChart.keiyu_uriage_nakaguro' | translate }}</h5></div><div class=widget-content><div ng-if=$ctrl.project.dailyReportStats class=chart-component><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.dashboard/conversion_price_chart.html
// module id = 1402
// module chunks = 0